import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      fill="none"
      viewBox="0 0 19 19"
    >
      <g clipPath="url(#clip0_1079_5)">
        <path
          fill="#001157"
          d="M7.407 8.431c.416.52.757 1.158.757 1.811v6.413c0 .668.238.935.787 1.336l1.35.816a.865.865 0 00.505.193c.297 0 .49-.252.49-.698v-8.06c-.015-.43.193-1.232.638-1.826l5.953-7.48c.43-.52.237-.936-.446-.936H1.56C.89 0 .683.43 1.113.95l6.294 7.481z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1079_5">
          <path fill="#fff" d="M0 0H19V19H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
